import { useState } from 'react';

export function Showing({type, dataTabel, opsiCabang}){
    
    const PAGE_SIZE_OPTIONS = [5, 10, 20, 30, "All"];
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    //use react tidak boleh setelah return

    if(!dataTabel) return null;
    const formatRibu = (value) => {
    if (value === null || value === undefined) return '0';
    return new Intl.NumberFormat('id-ID').format(Number(value));
        };
    const sourceData = (type === "dataUpload" || type === "dataUploadAll")
    ? dataTabel?.valid ?? []
    : dataTabel ?? [];

    const totalPages = Math.ceil(sourceData.length / pageSize);
    
    const paginatedData = sourceData.slice(
      (page - 1) * pageSize,
      page * pageSize
    )??[];
  
    const maxVisible = 5;
    let startPage = Math.max(1, page - Math.floor(maxVisible / 2));
    let endPage = startPage + maxVisible - 1;
    if (endPage > totalPages) {
      endPage = totalPages;
      startPage = Math.max(1, endPage - maxVisible + 1);
    }
    const visiblePages = [];  
    for (let i = startPage; i <= endPage; i++) {
    visiblePages.push(i);}

    const tabelDataLPJ = ()=>{return <>
                        <div className='row justify-content-end text-end'>
                          <div className="col-md-3 text-end">
                                <label className="form-label">Show</label>
                                <select
                                  className="form-select w-auto d-inline-block ms-2"
                                  value={pageSize}
                                  onChange={e => {
                                    setPageSize(Number(e.target.value));
                                    setPage(1);
                                  }}
                                >
                                  {PAGE_SIZE_OPTIONS.map(x => (
                                    <option key={x} value={x === 'All' ? sourceData.length : x}>{x}</option>
                                  ))}
                                </select>
                          </div>
                          </div>  
                       <table className="table table-bordered table-hover mt-3" id="TabelLPJ">
                          <thead className="table-secondary">
                            <tr>
                              <th>
                                <div className="text-center">
                                  <span>No</span>
                                </div>
                              </th>
                              <th>
                                <div className="d-flex justify-content-between align-items-center">
                                  <span>Sumber</span>
                                </div>
                              </th>
                              <th>
                                <div className="d-flex justify-content-between align-items-center">
                                  <span>Akun</span>
                                </div>
                              </th>
                              <th>
                                <div className="d-flex justify-content-between align-items-center">
                                  <span>Sub Akun</span>
                                </div>
                              </th>
                              <th>
                                <div className="text-center">
                                  <span>Nominal</span>
                                </div>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                              {paginatedData.map((row, i) => (
                                 <tr key={`${i + row.subakun??''}`}>
                                  <td className='text-end'>{i+1}</td>
                                  <td>{row.sumber}</td>
                                  <td>{row.akun}</td>
                                  <td>{row.subakun}</td>
                                  <td className = 'text-end'>{formatRibu(Number(row.nominal))}</td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                              <div className="d-flex justify-content-between align-items-center my-2 mx-3">
                                <div> 
                                    Showing {(page - 1) * pageSize + 1} to{" "}
                                    {Math.min(page * pageSize, paginatedData.length)} of{" "}
                                    {dataTabel.length} entries
                                </div>
                                <nav>
                                  <ul className="pagination mb-0">
                                    <li className={`page-item ${page === 1 && "disabled"}`}>
                                      <button
                                        className="page-link"
                                        onClick={() => setPage(1)}
                                      >
                                        ←
                                      </button>
                                    </li>

                                    {visiblePages.map(p => (
                                      <li
                                        key={p}
                                        className={`page-item ${page === p && "active"}`}
                                      >
                                        <button className="page-link" onClick={() => setPage(p)}>
                                          {p}
                                        </button>
                                      </li>
                                    ))}

                                    <li
                                      className={`page-item ${
                                        page === totalPages && "disabled"
                                      }`}
                                    >
                                      <button
                                        className="page-link"
                                        onClick={() => setPage(totalPages)}
                                      >
                                        →
                                      </button>
                                    </li>
                                  </ul>
                                </nav>
                              </div>
                                </>};
    const tabelDataUpload = ()=>{return <>
                        <div className='row justify-content-end text-end'>
                          <div className="col-md-3 text-end">
                                <label className="form-label">Show</label>
                                <select
                                  className="form-select w-auto d-inline-block ms-2"
                                  value={pageSize}
                                  onChange={e => {
                                    setPageSize(Number(e.target.value));
                                    setPage(1);
                                  }}
                                >
                                  {PAGE_SIZE_OPTIONS.map(x => (
                                    <option key={x} value={x === 'All' ? sourceData.length : x}>{x}</option>
                                  ))}
                                </select>
                          </div>
                          </div>  
                        <table className="table table-bordered table-hover mt-3" id="TabelUpload">
                          <thead className="table-secondary">
                            <tr>
                              <th>
                                <div className="text-center">
                                  <span>No</span>
                                </div>
                              </th>
                              <th>
                                <div className="d-flex justify-content-between align-items-center">
                                  <span>Sumber</span>
                                </div>
                              </th>
                              <th>
                                <div className="d-flex justify-content-between align-items-center">
                                  <span>Akun : SubAkun</span>
                                </div>
                              </th>
                              <th>
                                <div className="d-flex justify-content-between align-items-center">
                                  <span>Keterangan</span>
                                </div>
                              </th>
                              <th>
                                <div className="text-center">
                                  <span>Nominal</span>
                                </div>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                              {paginatedData.map((row, i) => (
                                <tr key={`${i + row.subakun??''}`}>
                                  <td className='text-end'>{i+1}</td>
                                  <td>{row.sumber}</td>
                                  <td>{`${row.akun} : ${row.subakun}`}</td>
                                  <td>{`${row.catatan}`}</td>
                                  <td className='text-end'>{formatRibu(parseInt(row.nominal))}</td>
                                </tr>
                              )) ?? null}
                          </tbody>
                        </table>

                        <div className="d-flex justify-content-between align-items-center my-2 mx-3">
                           <div> 
                                    Showing {(page - 1) * pageSize + 1} to{" "}
                                    {Math.min(page * pageSize, paginatedData.length)} of{" "}
                                    {dataTabel.length} entries
                                </div>
                                <nav>
                                  <ul className="pagination mb-0">
                                    <li className={`page-item ${page === 1 && "disabled"}`}>
                                      <button
                                        className="page-link"
                                        onClick={() => setPage(1)}
                                      >
                                        ←
                                      </button>
                                    </li>

                                    {visiblePages.map(p => (
                                      <li
                                        key={p}
                                        className={`page-item ${page === p && "active"}`}
                                      >
                                        <button className="page-link" onClick={() => setPage(p)}>
                                          {p}
                                        </button>
                                      </li>
                                    ))}

                                    <li
                                      className={`page-item ${
                                        page === totalPages && "disabled"
                                      }`}
                                    >
                                      <button
                                        className="page-link"
                                        onClick={() => setPage(totalPages)}
                                      >
                                        →
                                      </button>
                                    </li>
                                  </ul>
                                </nav>
                        </div>
                                </>}; 
    const tabelDataUploadAll = ()=>{return <>
                        <div className='row justify-content-end text-end'>
                          <div className="col-md-3 text-end">
                                <label className="form-label">Show</label>
                                <select
                                  className="form-select w-auto d-inline-block ms-2"
                                  value={pageSize}
                                  onChange={e => {
                                    setPageSize(Number(e.target.value));
                                    setPage(1);
                                  }}
                                >
                                  {PAGE_SIZE_OPTIONS.map(x => (
                                    <option key={x} value={x === 'All' ? sourceData.length : x}>{x}</option>
                                  ))}
                                </select>
                          </div>
                          </div>  
                        <table className="table table-bordered table-hover mt-3" id="TabelUpload">
                          <thead className="table-secondary">
                            <tr>
                              <th>
                                <div className="text-center">
                                  <span>Cabang</span>
                                </div>
                              </th>
                              <th>
                                <div className="d-flex justify-content-between align-items-center">
                                  <span>Sumber</span>
                                </div>
                              </th>
                              <th>
                                <div className="d-flex justify-content-between align-items-center">
                                  <span>Akun : SubAkun</span>
                                </div>
                              </th>
                              <th>
                                <div className="d-flex justify-content-between align-items-center">
                                  <span>Keterangan</span>
                                </div>
                              </th>
                              <th>
                                <div className="text-center">
                                  <span>Nominal</span>
                                </div>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                              {paginatedData.map((row, i) => (
                                <tr key={`${i+row.subakun??''}`}>
                                  <td>{opsiCabang.find(x => x.kode_cabang === row.cabang).nama_cabang}</td>
                                  <td>{row.sumber}</td>
                                  <td>{`${row.akun} : ${row.subakun}`}</td>
                                  <td>{`${row.catatan}`}</td>
                                  <td className='text-end'>{formatRibu(parseInt(row.nominal))}</td>
                                </tr>
                              )) ?? null}
                          </tbody>
                        </table>

                        <div className="d-flex justify-content-between align-items-center my-2 mx-3">
                           <div> 
                                    Showing {(page - 1) * pageSize + 1} to{" "}
                                    {Math.min(page * pageSize, paginatedData.length)} of{" "}
                                    {dataTabel.length} entries
                                </div>
                                <nav>
                                  <ul className="pagination mb-0">
                                    <li className={`page-item ${page === 1 && "disabled"}`}>
                                      <button
                                        className="page-link"
                                        onClick={() => setPage(1)}
                                      >
                                        ←
                                      </button>
                                    </li>

                                    {visiblePages.map(p => (
                                      <li
                                        key={p}
                                        className={`page-item ${page === p && "active"}`}
                                      >
                                        <button className="page-link" onClick={() => setPage(p)}>
                                          {p}
                                        </button>
                                      </li>
                                    ))}

                                    <li
                                      className={`page-item ${
                                        page === totalPages && "disabled"
                                      }`}
                                    >
                                      <button
                                        className="page-link"
                                        onClick={() => setPage(totalPages)}
                                      >
                                        →
                                      </button>
                                    </li>
                                  </ul>
                                </nav>
                        </div>
                                </>}; 

    switch(type){
      case "dataLPJ" : return (tabelDataLPJ());
      case "dataUpload" : return (tabelDataUpload())
      case "dataUploadAll" : return (tabelDataUploadAll())
    }  
  }